export const reportNationalNotesTypes = {
  SET_REPORT_NATIONAL_NOTES_FILTERS: 'SET_REPORT_NATIONAL_NOTES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};